import axios from "axios";

let axiosInstance = axios.create({
  // baseURL: "http://localhost:3000"
  baseURL: "https://p2-c1-branded-things.herokuapp.com/"
});

export default axiosInstance